import { useState, useRef, useEffect } from "react"

const STORAGE_KEY = "chat-sidebar-width"

const useChatSidebarResize = (initialWidth = 15) => {
  const [sidebarWidth, setSidebarWidth] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY)
    return saved ? parseFloat(saved) : initialWidth
  })

  const isResizingRef = useRef(false)
  const lastWidthRef = useRef(sidebarWidth || initialWidth)

  // Сохраняем в localStorage при каждом изменении ширины (кроме 0 = collapsed)
  useEffect(() => {
    if (sidebarWidth > 0) {
      localStorage.setItem(STORAGE_KEY, sidebarWidth)
      lastWidthRef.current = sidebarWidth
    }
  }, [sidebarWidth])

  const startResize = (e) => {
    e.preventDefault()
    isResizingRef.current = true

    const chatPanel =
      e.currentTarget.closest("[data-chat-panel]") ??
      e.currentTarget.parentElement?.parentElement?.parentElement
    const panelLeft = chatPanel?.getBoundingClientRect().left ?? 0
    const panelWidth = chatPanel?.offsetWidth ?? window.innerWidth

    const onMove = (e) => {
      if (!isResizingRef.current) return
      const w = ((e.clientX - panelLeft) / panelWidth) * 100
      if (w >= 10 && w <= 40) {
        setSidebarWidth(w)
      }
    }

    const onUp = () => {
      isResizingRef.current = false
      document.removeEventListener("mousemove", onMove)
      document.removeEventListener("mouseup", onUp)
    }

    document.addEventListener("mousemove", onMove)
    document.addEventListener("mouseup", onUp)
  }

  const collapse = () => {
    setSidebarWidth(0)
  }

  const expand = () => {
    const saved = localStorage.getItem(STORAGE_KEY)
    const w = saved ? parseFloat(saved) : lastWidthRef.current
    setSidebarWidth(w)
  }

  const setWidth = (w) => {
    setSidebarWidth(w)
  }

  return {
    sidebarWidth,
    setSidebarWidth: setWidth,
    isResizing: isResizingRef.current,
    startResize,
    collapse,
    expand,
  }
}

export default useChatSidebarResize
